import { render, staticRenderFns } from "./strategy.vue?vue&type=template&id=04958652&scoped=true&"
import script from "./strategy.vue?vue&type=script&lang=js&"
export * from "./strategy.vue?vue&type=script&lang=js&"
import style0 from "./strategy.vue?vue&type=style&index=0&id=04958652&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04958652",
  null
  
)

export default component.exports